import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TimeStampTableActions } from './time-stamp-table.actions';
import { TimeStampTableService } from '../../service/time-stamp-table.service';

@Injectable()
export class TimeStampTableEffects {

  loadTimeStamp$ = createEffect(
    (timeStampService: TimeStampTableService = inject(TimeStampTableService)) => {
      return this.actions$.pipe(
        ofType(TimeStampTableActions.loadTimeStamp),
        mergeMap((action) =>
          timeStampService.getTableEntriesUpdate(action.tableName, action.year, action.period).pipe(
            map((response: any) => {
              const data = response?.data?.tableEntriesUpdate;
              
             
              
              return TimeStampTableActions.loadTimeStampSuccess({
                tableName: action.tableName,
                lastUpdateTimestamp: data?.tableTimestamp || ''
              });
            }),
            catchError((error) => of(TimeStampTableActions.loadTimeStampFailure({ tableName: action.tableName, error })))
          )
        )
      );
    }
  );

  constructor(private actions$: Actions) {}
}
